export const setHOME = "setHOME";
export const setREQUEST = "setREQUEST";
export const setTICKETING = "setTICKETING";
export const setCURRENTREQUESTS = "setCURRENTREQUESTS";
export const setCONTACTLIST = "setCONTACTLIST";
export const setHELP = "setHELP";
export const setADMINPANEL = "setADMINPANEL";
export const setREQUESTVIEW = "setREQUESTVIEW";
